import BasicRouterView from "../../../components/BasicRouterView.vue";

const processosRoutes = {
  path: "proc",
  redirect: { name: "perfis-papeis" },
  meta: {
    label: "Processos",
    icon: "rebase_edit",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "processos/processos",
      name: "processos",
      meta: {
        label: "Funções",
        icon: "list",
        show: true,
        keepAlive: true,
      },
      component: () =>
        import(/* webpackChunkName: "perfis" */ "./views/ListarFuncoes.vue"),
    },
    {
      path: "processos/pessoas/:id",
      name: "pessoas",
      meta: {
        label: "Funções",
        icon: "list",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "perfis" */ "../processos/views/ListarPessoas.vue"
        ),
    },
    {
      path: "processos/epi/:id/:nome",
      name: "epi",
      meta: {
        label: "Funções",
        icon: "list",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "perfis" */ "./views/ListarEPI.vue"),
    },
  ],
};

export default processosRoutes;
